import { useDisclosure } from '@mantine/hooks';
import {
	useApiAddBookmarkToEntity,
	useApiRemoveBookmarkFromEntity,
} from '@repo/api-codegen';
import { IconButton } from '@repo/foundations';
import { includes } from 'lodash-es';
import { observer } from 'mobx-react-lite';
import type { ISecodaEntity } from '../../api';
import { useAuthUser } from '../../api';
import type { SecodaEntity } from '../../lib/models';

export interface IBookmarkToggleProps {
	entity: SecodaEntity | ISecodaEntity;
}

const BookmarkToggle = observer(({ entity }: IBookmarkToggleProps) => {
	const { mutateAsync: addBookmark } = useApiAddBookmarkToEntity({});
	const { mutateAsync: removeBookmark } = useApiRemoveBookmarkFromEntity({});
	const { user } = useAuthUser();

	const [isBookmarked, { toggle }] = useDisclosure(
		includes(entity.bookmarked_by, user.id)
	);

	const onClick = () => {
		let { bookmarked_by } = entity;
		if (isBookmarked) {
			removeBookmark({
				pathParams: {
					entityId: entity.id,
				},
			});
			bookmarked_by = entity.bookmarked_by.filter((b) => b !== user.id);
			toggle();
		} else {
			addBookmark({
				pathParams: {
					entityId: entity.id,
				},
			});
			bookmarked_by.push(user.id);
			toggle();
		}
	};

	return (
		<IconButton
			tooltip={`${isBookmarked ? 'Remove' : 'Add'} bookmark`}
			onClick={onClick}
			fillIcon={isBookmarked}
			iconName="bookmark"
			variant="tertiary"
		/>
	);
});

export default BookmarkToggle;
